export const isClosedZone = ({closedZone}) => closedZone === "Y";
export const isSterilizationZone = ({isSterilization}) => isSterilization === "Y";

export const getContactProximity = (geofenceInfo, target) => (geofenceInfo.contactProximity ? geofenceInfo.contactProximity : target.contactProximity);
export const getContactDuration = (geofenceInfo, target) => (geofenceInfo.contactDuration ? geofenceInfo.contactDuration : target.contactDuration);